<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.eventCategory')"
    resource="event_categories"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class EventCategories extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'name_cont',
        label: this.$t('eventCategory.name'),
        renderCell: {
          component: 'input'
         }
      },
    ]
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'name',
        label: this.$t('eventCategory.name'),
      },
      {
        prop: 'created_at',
        label: this.$t('createdAt'),
        renderCell: 'time',
      },
      {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        renderCell: 'time',
      },
    ].filter(Boolean)

  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'name',
        label: this.$t('eventCategory.name'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
    ]
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'event_categories.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'event_categories.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/event_categories',
    name: 'event_categories.index',
    component: EventCategories,
    props: {
      type: 'index',
    }
  },
  {
    path: '/event_categories/new',
    name: 'event_categories.new',
    component: EventCategories,
    props: {
      type: 'new',
    }
  },
  {
    path: '/event_categories/:id',
    name: 'event_categories.show',
    component: EventCategories,
    props: {
      type: 'show',
    }
  },
  {
    path: '/event_categories/:id/edit',
    name: 'event_categories.edit',
    component: EventCategories,
    props: {
      type: 'edit'
    }
  }
]
</script>
